module.exports = __webpack_public_path__ + "img/kehu_8@2x.c75d395d.png";